export enum EUserDetailsStatus {
  NEW = 'new',
  UNVERIFIED = 'unverified',
  VERIFIED = 'verified',
  NO_VERIFICATION_REQUIRED = 'noVerificationRequired',
}
